module.exports = __webpack_public_path__ + "static/google_play_footer.svg";